<template>
  <div class="container">
    <br /><br /><br />
    <template v-if="module_feature_toggle">
      <v-row>
        <v-col cols="12" sm="2" md="2" dense v-for="(item, i) in links" :key="i">
          <v-card :elevation="2" v-if="i % 2 == 0" class="card1" fill-height @click="show_feature(item)">
            <v-img height="150px">
              <center>
                <v-avatar color="#8ab6f8" class="avatar-icon mt-4" size="60">
                  <span>
                    <v-icon size="50" x-large color="black" class="link-icon">{{ item.icon }}</v-icon>
                  </span>
                </v-avatar>
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <strong><span class="linkname">{{ item.name }}</span></strong>
                  </center>
                </v-col>
              </center>
            </v-img>
          </v-card>
          <v-card :elevation="2" v-else class="card2" fill-height @click="show_feature(item)">
            <v-img height="150px">
              <center>
                <v-avatar color="#8ab6f8" class="avatar-icon mt-4" size="60">
                  <span>
                    <v-icon size="50" x-large color="black" class="link-icon">{{ item.icon }}</v-icon>
                  </span>
                </v-avatar>
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <strong><span class="linkname">{{ item.name }}</span></strong>
                  </center>
                </v-col>
              </center>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <v-btn class="button no-display" @click="module_feature_toggle = true">
        <v-icon>mdi-home</v-icon> </v-btn><br /><br />
      <v-row dense>
        <v-col cols="12" sm="3" md="3" dense v-for="(link, i) in features" :key="i">
          <router-link :to="{ path: link.link }" class="sidebar-link">
            <v-card :elevation="2" v-if="i % 2 == 0" class="card1">
              <v-img height="150px">
                <center>
                  <v-avatar color="#8ab6f8" class="avatar-icon mt-4" size="60">
                    <span>
                      <v-icon size="50" x-large color="black" class="link-icon">{{ link.icon }}</v-icon>
                    </span>
                  </v-avatar>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <strong><span class="linkname">{{ link.name }}</span></strong>
                    </center>
                  </v-col>
                </center>
              </v-img>
            </v-card>
            <v-card v-else :elevation="2" class="card2">
              <v-img height="150px">
                <center>
                  <v-avatar color="#8ab6f8" class="avatar-icon mt-4" size="60">
                    <span>
                      <v-icon size="50" x-large color="black" class="link-icon">{{ link.icon }}</v-icon>
                    </span>
                  </v-avatar>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <strong><span class="linkname">{{ link.name }}</span></strong>
                    </center>
                  </v-col>
                </center>
              </v-img>
            </v-card>
          </router-link>
        </v-col>
      </v-row>
    </template>
  </div>
</template>



<script>
import "@/assets/css/color.css";
import axios from "axios";

export default {
  data() {
    return {
      module_feature_toggle: true,
      is_management_user: false,
      tenant: "",
      links: [], // Dynamic links
      features: [],
    };
  },
  methods: {
    show_feature(item) {
      this.features = item.children;
      this.show_items2 = false;

      // Custom logic for "zeal" tenant and "Academics" module
      if (
        this.tenant === "zeal" &&
        item.name === "Academics" &&
        item.children.length === 7
      ) {
        console.log("in academics::", item.children.length);
        let removed = this.features.splice(3, 2);
        console.log("features in if cond", removed);
      }

      this.module_feature_toggle = false;
    },
    onload() {
      axios
        .post("Management/getManagementUsers")
        .then((res) => {
          if (res.data.flag === "YES") {
            this.is_management_user = res.data.is_management_user;
            this.links = res.data.links;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    },
  },
  mounted() {
    this.onload();
  },
  created() {
    this.tenant = localStorage.getItem("EPS-tenant");
  },
};
</script>



<style scoped>
.card1 {
  margin: 8px;
  height: 100%;
  border-radius: 20px !important;
  /* color: orange; */
  /* background-color: #D3D3D3; */
  /* background-color: #f4a688; */
  /* color: #674d3c; */
  background-color: #f8f88a;
  color: #485f3f;
}

.card1:hover {
  background: #bdc3c7;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #515e6b,
      #bdc3c7);
  /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right, #aa221b, #e94e4e); */
  background: linear-gradient(to right, #ffff66, #edf038);

  color: rgb(128 2 112) !important;
  font-weight: bold !important;
  text-align: center;
  box-shadow: 20px 20px 20px #f4a688 !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}

.card2 {
  margin: 8px;
  height: 100%;
  border-radius: 20px !important;
  /* color: orange; */
  /* background-color: #D3D3D3; */
  /* background-color: #f4a688; */
  /* color: #674d3c; */
  background-color: #8ab6f8;
  color: #485f3f;
}

.card2:hover {
  background: #bdc3c7;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #515e6b,
      #bdc3c7);
  /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right, #aa221b, #e94e4e); */
  background: linear-gradient(to right, #ffff66, #edf038);

  color: rgb(128 2 112) !important;
  font-weight: bold !important;
  text-align: center;
  box-shadow: 20px 20px 20px #f4a688 !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}

.sidebar-link {
  text-decoration: none;
}
</style>
